module.exports = __webpack_public_path__ + "static/media/banner.01c45849.png";